import { render, staticRenderFns } from "./OCR.vue?vue&type=template&id=49942e74&scoped=true&"
import script from "./OCR.vue?vue&type=script&lang=js&"
export * from "./OCR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49942e74",
  null
  
)

export default component.exports